/**
 * SQL Monitor 리포트 — 결과 영역의 「SQL Monitor 리포트」 가 연다(2026-10-13, 백엔드 database/lastExec.js).
 *
 * 그 결과 탭의 문장을 **다시 실행하지 않고**, 이미 돈 실행의 리포트(DBMS_SQLTUNE.REPORT_SQL_MONITOR, TEXT)를 그대로 보여 준다.
 * Tuning Pack 라이선스 기능이라 사용자가 단추를 눌렀을 때만 받는다. 기록이 없으면(5초 미만·직렬 문장) 그 까닭을 말한다.
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { FiFileText, FiCopy } from 'react-icons/fi';
import AppModal from './common/AppModal';
import { monoWideText } from '../utils/monoWide';
import './ExecMonitorModal.css';

function SqlMonitorReportModal({ open, onClose, data }) {
  const { t } = useTranslation();
  const report = (data && data.report) || '';
  const copy = useCallback(async () => {
    try { await navigator.clipboard.writeText(report); toast.success(t('common:lastExec.copied')); }
    catch (_e) { toast.error(t('common:lastExec.copyFailed')); }
  }, [report, t]);

  return (
    <AppModal open={open} onClose={onClose} title={t('common:lastExec.reportTitle')} icon={<FiFileText size={14} />} className="emon-modal smr-modal" windowed>
      <div className="emon-body">
        <div className="emon-bar">
          {data && data.exec ? <span className="emon-state">SQL_ID {data.exec.sqlId}</span> : null}
          {data && data.loading ? <span>{t('common:state.loading')}</span> : null}
          {data && data.exec && !data.pinned ? <span className="smr-warn">{t('common:lastExec.reportBySession')}</span> : null}
          <button type="button" className="app-btn smr-copy" onClick={copy} disabled={!report}><FiCopy size={11} /> {t('common:lastExec.copy')}</button>
        </div>
        {data && data.sql ? <div className="emon-sql" title={data.sql}>{String(data.sql).replace(/\s+/g, ' ').slice(0, 300)}</div> : null}
        {data && data.error ? <div className="emon-error" role="alert">{data.error}</div> : null}
        {report ? <pre className="emon-plan">{monoWideText(report)}</pre> : null}
      </div>
    </AppModal>
  );
}

SqlMonitorReportModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  /** { sql, loading, report, exec, pinned, error } */
  data: PropTypes.object,
};

export default SqlMonitorReportModal;
